import { useMemo } from 'react';
import { useQueryGetProjectChildProjects } from '../core/queries/projects.queries';

export function useDisplayWorkflowTypes(projectID: string) {
  const projects = useQueryGetProjectChildProjects(projectID);

  const displayWorkflowTypes = useMemo(() => {
    return [
      ...new Set(
        (projects.data || []).reduce(
          (acc, project) => [...acc, ...((project as any).displayWorkflowTypes || [])],
          [] as string[]
        )
      )
    ];
  }, [projects.data]);

  return [displayWorkflowTypes, projects.isLoading] as const;
}
